/**
 * Customer-safe copy for cash-payout rail failures.
 * Keep in sync with services/ott/ottPayoutCustomerCopy.js
 */

export const RAIL_INSUFFICIENT_CUSTOMER_MESSAGE =
  'This cash withdrawal could not be completed. Please try again later. The full amount has been returned to your wallet.';

export function isCashRailInsufficientFundsMessage(reason?: string | null): boolean {
  const r = String(reason || '').toLowerCase();
  if (!r.includes('insufficient funds')) return false;
  if (r.includes('unrestricted')) return false;
  if (r.includes('for this transaction')) return true;
  if (/insufficient funds\s*[-:]\s*\d/.test(r)) return true;
  return false;
}

export function customerFacingCashWithdrawalError(reason?: string | null, fallback?: string): string {
  if (isCashRailInsufficientFundsMessage(reason)) return RAIL_INSUFFICIENT_CUSTOMER_MESSAGE;
  const trimmed = String(reason || '').trim();
  return trimmed || fallback || RAIL_INSUFFICIENT_CUSTOMER_MESSAGE;
}
